import { localize } from "client_legacy/ndaw/culture";
import { UserRequestItemClientModel } from "client/Api/UserRequests/manageUserRequests";
import { UserRequestKind, UserRequestStatus } from "client/Api/UserRequests/userRequest";

const kindToTextMap: { [key in UserRequestKind]: string } = {
	[UserRequestKind.AppAccess]: localize("_App")
};

const statusToTextMap: { [key in UserRequestStatus]: string } = {
	[UserRequestStatus.Open]: localize("_Open"),
	[UserRequestStatus.Accepted]: localize("_Accepted"),
	[UserRequestStatus.Declined]: localize("_Declined"),
};

export function getUserRequestKindText(kind: UserRequestKind): string {
	return kindToTextMap[kind];
}

export function getUserRequestStatusText(status: UserRequestStatus): string {
	return statusToTextMap[status];
}

export function getUserRequestItemName(item: UserRequestItemClientModel): string {
	switch (item.kind)
	{
		case UserRequestKind.AppAccess:
			return item.name;
		default:
			throw new Error("Not supported");
	}
}
